import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const LinedRewards: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#333' }) => (
  /*@ts-ignore*/
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 40 40">
    <path
      fill={fill}
      fill-rule="evenodd"
      d="M20 3.333c6.444 0 11.667 5.224 11.667 11.667 0 2.198-.608 4.254-1.665 6.01L30 33.528c0 1.381-1.12 2.5-2.5 2.5-.362 0-.72-.078-1.047-.23l-.24-.126-5.355-3.214c-.462-.277-1.025-.311-1.512-.104l-.203.104-5.357 3.214c-1.184.71-2.72.327-3.43-.857-.186-.311-.302-.658-.341-1.016l-.015-.27V21.012C8.942 19.257 8.334 17.2 8.334 15 8.334 8.557 13.556 3.334 20 3.334zm6.667 28.724l.002-7.483c-1.89 1.32-4.19 2.093-6.669 2.093-2.479 0-4.777-.773-6.667-2.092v7.482l4.095-2.457c1.484-.89 3.316-.946 4.843-.167l.302.167 4.094 2.457.002-7.483-.002 7.483zM20 6.667c-4.602 0-8.333 3.73-8.333 8.333s3.73 8.334 8.333 8.334c4.602 0 8.333-3.731 8.333-8.334 0-4.602-3.73-8.333-8.333-8.333z"
      clip-rule="evenodd"
    />
  </svg>
);

export default LinedRewards;
